import { CancelToken } from 'axios';
import { http } from '../helpers/axiosHelper';

export default class candidateService {
   async getCandidates(
      page?: Number,
      perPage?: Number,
      journeyParams?: String,
      startBirthdate?: String,
      endBirthdate?: String,
      startUpdate?: String,
      endUpdate?: String,
      candidateSearch?: String,
      cancelToken?: CancelToken
   ) {
      return await http
         .get(import.meta.env.VITE_APP_API_BASE_URL_DATA + `/candidate?page=${page}${journeyParams}`, {
            params: {
               per_page: perPage,
               'birthdate-from': startBirthdate,
               'birthdate-until': endBirthdate,
               'updated-at-from': startUpdate,
               'updated-at-until': endUpdate,
               search: candidateSearch,
            },
            cancelToken: cancelToken,
         })
         .then((response) => {
            return response.data;
         });
   }

   async suggestJourney(candidates: Array<Number>, journeyId: Number, referralId: Number, sendMail: Boolean, sendSms: Boolean) {
      return await http
         .post(import.meta.env.VITE_APP_API_BASE_URL_DATA + `/candidate/suggest`, {
            candidates: candidates,
            journey_id: journeyId,
            referral_id: referralId,
            send_mail: sendMail,
            send_sms: sendSms,
         })
         .then((response) => {
            return response.data;
         });
   }

   async postCandidate(candidate: Object) {
      return await http.post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/candidate', candidate).then((response) => {
         return response.data;
      });
   }
}
